import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Observable, Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatDialog} from '@angular/material/dialog';
import {ExcelService} from '../../../../services/excel.service';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-cd-uc-data',
  templateUrl: './cd-uc-data.component.html',
  styleUrls: ['./cd-uc-data.component.css']
})

export class CdUcDataComponent implements OnInit, OnDestroy {
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  patientSSN: string;
  // subscribe and unsubscribe
  subscription: Subscription;
  subscription1: Subscription;
  subscription2: Subscription;
  // per la tabella
  dataSource;
  dataSourceArray = [];
  totalSize = 0;
  isDataAvailable = false;

  // head of the table
  patientElements = ['name', 'surname','Sex','birthdate','Age','DateOfDiagnosis','AgeAtDiagnosis','Familiarity','Group','Pathology','PathologyDuration','Weight','Height','Interventi','NumResezioni', 
  'LocatColonCD','LocatIleumCD','LocatUpperGI','LocalizzazioneUC','InfiammatorioCD','MalattiaPerianaleCD','PenetranteCD','StenosanteCD','Stomia',
  'TherapyTOPICA','TherapyIMM','TherapyGCSOS','TherapyFiveASAOS','TherapyBIO','AttiveEIMS','StoricheEIMS','Patient SCCAI date',  'Patient SCCAI score', 'Patient PRISM date','Patient PRISM score', 'Patient HBI date','Patient HBI score'];
  juniorElements = ['Junior ID','Junior CLINICAL-SCCAI date', 'Junior CLINICAL-SCCAI score','Junior CLINICAL-PRISM date',
  'Junior CLINICAL-PRISM score','Junior CLINICAL-HBI date', 'Junior CLINICAL-HBI score'];
  seniorElements = ['Senior CLINICAL-SCCAI date 1', 'Senior CLINICAL-SCCAI score 1','Senior CLINICAL-PRISM date 1',
    'Senior CLINICAL-PRISM score 1','Senior CLINICAL-HBI date 1', 'Senior CLINICAL-HBI score 1'];
  headTotalElements= ['name', 'surname','Sex','birthdate','Age','DateOfDiagnosis','AgeAtDiagnosis','Familiarity','Group','Pathology','PathologyDuration','Weight','Height','Interventi','NumResezioni', 
  'LocatColonCD','LocatIleumCD','LocatUpperGI','LocalizzazioneUC','InfiammatorioCD','MalattiaPerianaleCD','PenetranteCD','StenosanteCD','Stomia',
  'TherapyTOPICA','TherapyIMM','TherapyGCSOS','TherapyFiveASAOS','TherapyBIO','AttiveEIMS','StoricheEIMS','Patient SCCAI date',  'Patient SCCAI score', 'Patient PRISM date', 'Patient PRISM score', 'Patient HBI date','Patient HBI score','Senior CLINICAL-SCCAI date 1', 'Senior CLINICAL-SCCAI score 1','Senior CLINICAL-PRISM date 1',
  'Senior CLINICAL-PRISM score 1','Senior CLINICAL-HBI date 1', 'Senior CLINICAL-HBI score 1','Junior ID','Junior CLINICAL-SCCAI date', 'Junior CLINICAL-SCCAI score','Junior CLINICAL-PRISM date',
  'Junior CLINICAL-PRISM score','Junior CLINICAL-HBI date', 'Junior CLINICAL-HBI score'];
  // per il paginator
  public pageSize = 5;
  public currentPage = 0;
  public tasks: any[];
  //
  @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }
  constructor(private router: Router,
              private store: Store<AppState>,
              private doctorService: DoctorService,
              public dialog: MatDialog,
              private excelService: ExcelService,
              public datepipe: DatePipe) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }

  ngOnInit(): void {
    this.subscription = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.getUCCDComparisons();
    })
  }
  ngOnDestroy(){
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription.unsubscribe();
  }
  getUCCDComparisons(){
    this.getUCComparisons();
    this.getCDComparisons();

  }

  getUCComparisons() {
    this.subscription1 = this.doctorService.getClinicalPatientUCComparisons().subscribe(data => {
      // lunghezza totale
      const elements = Object.keys(data).length;
            /* INIZIO OLD VERSION

      // inizializzo il numero totale di senior e junior a 0, mi serve sapere quanti sono
      // per costruire la tabella
      let numberOfAllSenior = 0;
      let numberOfAllJunior = 0;
      // itero su ogni riga di data per andare a trovare il numero totale di junior e di senior valutanti
      for (let i = 0; i < elements; i++) {
        let numberOfSeniorPatient = 0; // senior su una riga
        let numberOfJuniorPatient = 0; // junior su una riga
        // itero sulle keys di ogni riga
        for (var key of Object.keys(data[i])) {
          if (key.includes('Senior ID')) {
            //console.log("Entry variables: " + key.split(' ', 3));
            numberOfSeniorPatient = Number(key.split(' ', 3)[2]);
            //console.log("Number of senior patients: " + numberOfSeniorPatient);
            if (numberOfSeniorPatient > numberOfAllSenior) {
              numberOfAllSenior = numberOfSeniorPatient;
            }
            // numberOfSeniorPatient += 1;
          }
          if (key.includes('Junior ID')) {
          
            numberOfJuniorPatient = Number(key.split(' ', 3)[2]);
            if (numberOfJuniorPatient > numberOfAllJunior) {
              numberOfAllJunior = numberOfJuniorPatient;
            }
            // numberOfJuniorPatient += 1;
          }

        }
      }
      // metto tutti gli header insieme
      // console.log(numberOfAllJunior);
      // console.log(totalJuniorHeader);
      // console.log(numberOfAllSenior);
      // console.log(totalSeniorHeader);
      // tslint:disable-next-line:max-line-length
      //this.headTotalElements = this.headTotalElements.concat(this.patientElements, this.seniorElements, this.juniorElements);
      //console.log(this.headTotalElements);
FINE OLD VERSION */

      // ora bisogna riorganizzare i dati per inserirli in tabella correttamente
      // I CAMPI CON CUI SONO SALVATI NEL DIZIONARIO RITORNATO DAL BACK-END CORRISPONDONO AI NOMI DELLE COLONNE DELLA
      // TABELLA, QUESTO RENDE PIù FACILE L'ASSOCIAZIONE
      for (let element = 0; element < elements; element ++) {
        // per prima cosa creo una riga inizializzata vuota per ogni campo (con dei '-')
        let array = new Map<string, string>();
        /*const stringa = '-';
        this.headTotalElements.forEach(item => {
          array.set(key, item);
          array[item] = stringa;
          // array = array.concat(stringa);
        }); */
        for (let k = 0; k < this.headTotalElements.length; k ++) {
          for (let kk = 0; kk < Object.keys(data[element]).length; kk++) {
            //sistemo junior
            if((Object.keys(data[element])[kk].startsWith("Junior ID")  && this.headTotalElements[k].startsWith("Junior ID")) ||
            (Object.keys(data[element])[kk].startsWith("Junior CLINICAL-SCCAI date")  && this.headTotalElements[k].startsWith("Junior CLINICAL-SCCAI date")) ||
            (Object.keys(data[element])[kk].startsWith("Junior CLINICAL-PRISM score")  && this.headTotalElements[k].startsWith("Junior CLINICAL-PRISM score")) ||
            (Object.keys(data[element])[kk].startsWith("Junior CLINICAL-PRISM date")  && this.headTotalElements[k].startsWith("Junior CLINICAL-PRISM date")) ||
            (Object.keys(data[element])[kk].startsWith("Junior CLINICAL-SCCAI score")  && this.headTotalElements[k].startsWith("Junior CLINICAL-SCCAI score")) ||
            (Object.keys(data[element])[kk].startsWith("Junior CLINICAL-HBI date")  && this.headTotalElements[k].startsWith("Junior CLINICAL-HBI date")) ||
            (Object.keys(data[element])[kk].startsWith("Junior CLINICAL-HBI score")  && this.headTotalElements[k].startsWith("Junior CLINICAL-HBI score")))
            array[this.headTotalElements[k]] = Object.values(data[element])[kk]; 
           
            // se il determinato campo è presente nel dizionario allora lo inserisco in tabella al posto giusto
           else if (Object.keys(data[element])[kk] === this.headTotalElements[k]) {
            /*  
            //lo inserisco pulito
              if(Object.keys(data[element])[kk] === 'Sex') 
              array[this.headTotalElements[k]] = this.sexOptions[parseInt(Object.values(data[element])[kk].toString())];
              else if(Object.keys(data[element])[kk] === 'Familiarity' || Object.keys(data[element])[kk] === 'Interventi' || Object.keys(data[element])[kk] === 'StoricheEIMS' || Object.keys(data[element])[kk] === 'AttiveEIMS'
              || Object.keys(data[element])[kk] === 'InfiammatorioCD'|| Object.keys(data[element])[kk] === 'LocatColonCD'|| Object.keys(data[element])[kk] === 'LocatIleumCD' 
              || Object.keys(data[element])[kk] === 'LocatUpperGI' ||  Object.keys(data[element])[kk] === 'MalattiaPerianaleCD' || Object.keys(data[element])[kk] === 'PenetranteCD' 
              || Object.keys(data[element])[kk] === 'StenosanteCD' || Object.keys(data[element])[kk] === 'Stomia') 
              array[this.headTotalElements[k]] = this.options[parseInt(Object.values(data[element])[kk].toString())];
              else if(Object.keys(data[element])[kk] === 'LocalizzazioneUC' ) 
              array[this.headTotalElements[k]] = this.localizationUC[parseInt(Object.values(data[element])[kk].toString())];
              //lo inserisco uguale a come arriva
              else*/
              array[this.headTotalElements[k]] = Object.values(data[element])[kk]; }
            }
          }
        
        // this.dataSource.push(array);
        this.dataSourceArray.push(array);
      }
      //this.getPagination(this.dataSourceArray);
    }, error => {
      if (error.status === 500) {
        localStorage.setItem('expirationTime', '0');
        console.log('SESSIONE SCADUTA');
        location.reload();
      }
    });
  }


  getCDComparisons() {
    this.subscription2 = this.doctorService.getClinicalPatientCDComparisons().subscribe(data => {
      // lunghezza totale
      const elements = Object.keys(data).length;

      /*INIZIO OLD VERSION
      
      // inizializzo il numero totale di senior e junior a 0, mi serve sapere quanti sono
      // per costruire la tabella
      let numberOfAllSenior = 0;
      let numberOfAllJunior = 0;
      // itero su ogni riga di data per andare a trovare il numero totale di junior e di senior valutanti
      for (let i = 0; i < elements; i++) {
        let numberOfSeniorPatient = 0; // senior su una riga
        let numberOfJuniorPatient = 0; // junior su una riga
        // itero sulle keys di ogni riga
        for (var key of Object.keys(data[i])) {
          if (key.includes('Senior ID')) {
            //console.log("Entry variables: " + key.split(' ', 3));
            numberOfSeniorPatient = Number(key.split(' ', 3)[2]);
            //console.log("Number of senior patients: " + numberOfSeniorPatient);
            if (numberOfSeniorPatient > numberOfAllSenior) {
              numberOfAllSenior = numberOfSeniorPatient;
            }
            // numberOfSeniorPatient += 1;
          }
          if (key.includes('Junior ID')) {
            numberOfJuniorPatient = Number(key.split(' ', 3)[2]);
            if (numberOfJuniorPatient > numberOfAllJunior) {
              numberOfAllJunior = numberOfJuniorPatient;
            }
            // numberOfJuniorPatient += 1;
          }
        }
      }
      // metto tutti gli header insieme
      // console.log(numberOfAllJunior);
      // console.log(totalJuniorHeader);
      // console.log(numberOfAllSenior);
      // console.log(totalSeniorHeader);
      // header finale della tabella
      // tslint:disable-next-line:max-line-length
      //this.headTotalElements = this.headTotalElements.concat(this.patientElements, this.seniorElements, this.juniorElements);
      //console.log(this.headTotalElements);

      FINE OLD VERSION*/
      
      // ora bisogna riorganizzare i dati per inserirli in tabella correttamente
      // I CAMPI CON CUI SONO SALVATI NEL DIZIONARIO RITORNATO DAL BACK-END CORRISPONDONO AI NOMI DELLE COLONNE DELLA
      // TABELLA, QUESTO RENDE PIù FACILE L'ASSOCIAZIONE
      for (let element = 0; element < elements; element ++) {
        // per prima cosa creo una riga inizializzata vuota per ogni campo (con dei '-')
        let array = new Map<string, string>();
        /*
        const stringa = '-';
        this.headTotalElements.forEach(item => {
          array.set(key, item);
          array[item] = stringa;
          // array = array.concat(stringa);
        });
*/
        for (let k = 0; k < this.headTotalElements.length; k ++) {
          for (let kk = 0; kk < Object.keys(data[element]).length; kk++) {
            //sistemo junior
            if((Object.keys(data[element])[kk].startsWith("Junior ID")  && this.headTotalElements[k].startsWith("Junior ID")) ||
            (Object.keys(data[element])[kk].startsWith("Junior CLINICAL-SCCAI date")  && this.headTotalElements[k].startsWith("Junior CLINICAL-SCCAI date")) ||
            (Object.keys(data[element])[kk].startsWith("Junior CLINICAL-PRISM score")  && this.headTotalElements[k].startsWith("Junior CLINICAL-PRISM score")) ||
            (Object.keys(data[element])[kk].startsWith("Junior CLINICAL-PRISM date")  && this.headTotalElements[k].startsWith("Junior CLINICAL-PRISM date")) ||
            (Object.keys(data[element])[kk].startsWith("Junior CLINICAL-SCCAI score")  && this.headTotalElements[k].startsWith("Junior CLINICAL-SCCAI score")) ||
            (Object.keys(data[element])[kk].startsWith("Junior CLINICAL-HBI date")  && this.headTotalElements[k].startsWith("Junior CLINICAL-HBI date")) ||
            (Object.keys(data[element])[kk].startsWith("Junior CLINICAL-HBI score")  && this.headTotalElements[k].startsWith("Junior CLINICAL-HBI score")))
            array[this.headTotalElements[k]] = Object.values(data[element])[kk]; 
            // se il determinato campo è presente nel dizionario allora lo inserisco in tabella al posto giusto
           else if (Object.keys(data[element])[kk] === this.headTotalElements[k]) {
             /*
              //lo inserisco pulito
              if(Object.keys(data[element])[kk] === 'Sex') 
              array[this.headTotalElements[k]] = this.sexOptions[parseInt(Object.values(data[element])[kk].toString())];
              else if(Object.keys(data[element])[kk] === 'Familiarity' || Object.keys(data[element])[kk] === 'Interventi' || Object.keys(data[element])[kk] === 'StoricheEIMS' || Object.keys(data[element])[kk] === 'AttiveEIMS'
              || Object.keys(data[element])[kk] === 'InfiammatorioCD'|| Object.keys(data[element])[kk] === 'LocatColonCD'|| Object.keys(data[element])[kk] === 'LocatIleumCD' 
              || Object.keys(data[element])[kk] === 'LocatUpperGI' ||  Object.keys(data[element])[kk] === 'MalattiaPerianaleCD' || Object.keys(data[element])[kk] === 'PenetranteCD' 
              || Object.keys(data[element])[kk] === 'StenosanteCD' || Object.keys(data[element])[kk] === 'Stomia') 
              array[this.headTotalElements[k]] = this.options[parseInt(Object.values(data[element])[kk].toString())];
              else if(Object.keys(data[element])[kk] === 'LocalizzazioneUC' ) 
              array[this.headTotalElements[k]] = this.localizationUC[parseInt(Object.values(data[element])[kk].toString())];
              //lo inserisco uguale a come arriva
              else*/
              array[this.headTotalElements[k]] = Object.values(data[element])[kk]; }
            }
        }
        // this.dataSource.push(array);
        this.dataSourceArray.push(array);
        // console.log(array);
      }
      this.isDataAvailable = true;
      this.getPagination(this.dataSourceArray);
    }, error => {
      if (error.status === 500) {
        localStorage.setItem('expirationTime', '0');
        console.log('SESSIONE SCADUTA');
        location.reload();
      }
    });
  }
  exportAsXLSX(): void {
    let dateTime = new Date();
    let latest_date = this.datepipe.transform(dateTime, 'yyyy-MM-dd');
    console.log(this.dataSourceArray);
    this.excelService.exportAsExcelFile(this.dataSourceArray,this.headTotalElements, 'Malattia_Crohn_Rettocolite_ulcerosa_CONCORDANZA_' + latest_date.toString());
  }
  // paginazione effettuata manualmente
  getPagination(data) {
    this.dataSource = new MatTableDataSource<any>();
    this.tasks = data;
    this.totalSize = this.tasks.length;
    this.currentPage = 0;
    this.iterator(); // iterator sistema i nomi alla pagina corretta
  }
  handlePage(event?: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.iterator();
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    this.dataSource.data = this.tasks.slice(start, end);
  }

}
